export default __webpack_public_path__ + "assets/images/4f640a097ee2acbd29bcd91b9639ac03.png";